import { ArrowUpRight } from "lucide-react";

const HEADLINES = [
  {
    outlet: "Media Release · 25 May 2026",
    title: "RevGrow launches AI-Native Demand Generation delivery vertical.",
    excerpt: "A dedicated Demand Generation Delivery practice, supported by a high-calibre offshore team in Hyderabad, extends the firm from advisory into end-to-end demand execution.",
  },
  {
    outlet: "Forbes · Brand Connect",
    title: "Bridging strategy and execution — RevGrow's integrated growth model.",
    excerpt: "A rare combination in the European B2B market — strategic credibility with in-house execution depth of specialist agencies and offshore scale economics.",
  },
  {
    outlet: "B2B Marketing",
    title: "The one-accountable-partner playbook for high-growth teams.",
    excerpt: "Clients demand strategic clarity and execution muscle from one partner — RevGrow's response is a single, integrated model from insight to booked pipeline.",
  },
];

export default function MediaPress() {
  return (
    <section id="media-press" data-testid="media-press-section" className="relative py-24 md:py-32 border-t border-white/5 bg-[#040810]">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-teal mb-4">
            Media & Press
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-[56px] leading-[1] tracking-[-0.02em]">
            As seen &amp; recognised <span className="italic font-normal text-teal">across the industry.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4">
          {HEADLINES.map((h) => (
            <div key={h.title} className="rounded-2xl border border-white/[0.06] bg-[#0A121A] p-7 card-hover">
              <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-teal mb-4">
                {h.outlet}
              </div>
              <h3 className="font-display text-lg font-semibold leading-tight mb-3">{h.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{h.excerpt}</p>
              <div className="mt-5 inline-flex items-center gap-1 text-xs text-teal">
                Read more <ArrowUpRight size={12} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
